import DeleteProjectBulletPointModal from './DeleteProjectBulletPointModal'

export default DeleteProjectBulletPointModal
